import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { FundraiserCardComponent } from '../fundraiser-card/fundraiser-card.component';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-urgent-need-slide',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule,
    RouterModule,
    MatRippleModule,
    FundraiserCardComponent,
    HttpClientModule,
    SwiperModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  templateUrl: './urgent-need-slide.component.html',
  styleUrls: ['./urgent-need-slide.component.scss']
})
export class UrgentNeedSlideComponent {
  @Input() freqVisitedCampaigns: number[] = [];
  @Input() hideClause: boolean = false;
  @Input() customNav: boolean = false;
  @Input() useGlide: boolean = false;
  @Input() title: string = "Need Urgent help!";
  fundraisers = []
  eventInfo;
  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 3.3,
    initialSlide: 3,
    navigation: true,
    keyboard: false,
    scrollbar: false,
    loop: false,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
      waitForTransition: true
    },
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: true,
    breakpoints: {
      992: {
        slidesPerView: 1.3,
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        observer: true,
      },
      768: {
        slidesPerView: 1.3,
        autoplay: {
          delay: 2000,
          disableOnInteraction: true,
          waitForTransition: true
        },
        initialSlide: 1,
      }
    }
  };

  causes = [
    { cause: 'medical', text: 'Medical', icon: 'medical_services' },
    { cause: 'animals', text: 'Animals', icon: 'pets' },
    { cause: 'education', text: 'Education', icon: 'school' },
    // { cause: 'food_hunger', text: 'Food and Hunger', icon: 'restaurant' },
    { cause: 'women_girls', text: 'Women & Girls', icon: 'woman' },
    { cause: 'children', text: 'Children', icon: 'medical_services' }
  ];
  fundraiserLoading = false;

  selectedCauses = ['medical'];

  breakpoints = {
    600: {
      perView: 1.3,
      showArrows: false,
      gap: 6
    }
  };

  constructor(
    public util: UtilService,
    private handler: HttpBackend,
    private events: EventsService,
    private vars: VariablesService
  ) {
    this.httpClient = new HttpClient(handler);
  }
  private httpClient: HttpClient | any;

  ngOnInit() {
    if(this.freqVisitedCampaigns?.length){
      this.getCurrency();
      this.config = {
        direction: 'horizontal',
        slidesPerView: 3.3,
        initialSlide: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        keyboard: false,
        scrollbar: false,
        loop: false,
        autoplay: false,
        observer: true,
        preloadImages: false,
        spaceBetween: 16,
        centeredSlides: false,
        pagination: true,
        breakpoints: {
          992: {
            slidesPerView: 1.3,
            centeredSlides: false,
            allowTouchMove: true,
            loop: false,
            autoplay: false,
            observer: true,
          },
          768: {
            navigation: false,
            slidesPerView: 1.3,
            autoplay: false,
            initialSlide: 1,
          }
        }
      }
    } else {
      this.getFundraiserLists();
    }
  }

  getCurrency() {
    this.util.currency.subscribe((res) => {
      if (res) {
        if (this.freqVisitedCampaigns?.length) {
          if(res){
            this.getFreqVisitedCampaigns(res, this.freqVisitedCampaigns).subscribe(resp=>{
              this.fundraisers = resp?.data;
            });
          } else {
            this.fundraisers = [];
          }
        }
      }
    });
  }

  getFreqVisitedCampaigns(currency, campaignsIds) {
    const KU = this.util.getCookie('_ku');
    const qparams = '&with=basicInfo';
    return this.httpClient.get(environment.APP.BASE_URL + `campaigns?&camp_ids=${campaignsIds?.join()}&currency=${currency.toLowerCase()}&_ku=${KU}${qparams}`);
  }

  getRandomNumber() {
    return this.util.randomIntFromInterval(1, 4);
  }

  getFundraiserLists() {
    const url = environment.meilisearch.host + '/indexes/' + environment.meilisearch.index + '/search';
    const token = environment.meilisearch.key;
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    const cause = this.getCauseTitleFromSelectedCause();
    const payload = {
      "q": "",
      "facets": ["tags"],
      "attributesToHighlight": ["*"],
      "highlightPreTag": "__ais-highlight__",
      "highlightPostTag": "__/ais-highlight__",
      "limit": 10, "offset": 0,
      "filter": [[`category=\'${cause}\'`]],
      "sort": [`rank_${this.getRandomNumber()}:asc`]
    }
    this.fundraiserLoading = true;
    this.httpClient.post(url, payload, { headers }).subscribe(val => {
      this.fundraisers = val.hits;
      this.fundraiserLoading = false;
    }, error => {
      this.fundraiserLoading = false;
    });
  }

  getCauseTitleFromSelectedCause(): string {
    return this.causes.find(item => item.cause === this.selectedCauses[0]).text;
  }

  filterCause(cause) {
    if (this.selectedCauses.includes(cause)) {
      this.selectedCauses = this.selectedCauses.filter(c => c !== cause);
    } else {
      this.selectedCauses = [cause];
    }
    this.events.sendSystemEvent({
      eventName: 'click_on_tab',
      page_name: this.vars.pageName,
      info_1: cause
    }).subscribe(_ => _);
    this.getFundraiserLists();
  }
}
